import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminToolsContextProvider from '../../../Context/AdminTools/index.js';

/**
 * Layout wrapper for ToolsV2 routes that provides the AdminToolsContext
 * This keeps the context isolated to only the tools pages instead of the entire app
 */
const ToolsV2Layout = ({ children }) => {
  return (
    <AdminToolsContextProvider>
      {children || <Outlet />}
    </AdminToolsContextProvider>
  );
};

export default ToolsV2Layout;

